import React, { useRef, useState, useEffect } from "react";
import { Carousel, Spinner } from "react-bootstrap";
import { getImageURLCookieDetails } from "../../../helpers/utils";
import "./imageSlider.scss";
import { useDispatch } from "react-redux";
import { getImageManufacturer, getPartImages } from "../../StoreDashboard/storeDashboard.thunks";

function ImagesSliderComponent({ partDetails, showImagesSlider }) {
  const dispatch = useDispatch();
  const [index, setIndex] = useState(0);
  const [curZoom, setCurZoom] = useState(0);
  const [imgStyle, setImgStyle] = useState({
    transform: "scale(1)",
    maxWidth: "150px",
    maxHeight: "150px",

    // maxWidth: "600px",
    // width: "100%",
  });
  const [thumbnailImgStyle, setThumbnailImgStyle] = useState({
    transform: "scale(1)",
    maxWidth: "200px",
    maxHeight: "200px",
    width: "100%",
    marginTop: "200px",
    marginLeft: "200px",
  });
  const imagePrintRef = useRef([]);
  const [partImages, setPartImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showImagesSlider && partDetails) {
      fetchPartImages(partDetails);
    }
  }, [showImagesSlider, partDetails]);

  const fetchPartImages = async (part) => {
    setLoading(true); // Set loading to true before starting the API call
    try {
      if (!part) {
        console.error("Part details are missing.");
        setLoading(false); // Set loading to false if part details are missing
        return;
      }

      const manufacturePayload = {
        partNumber: part.partNumber || "",
        mfgCode: part.mfgCode || "",
      };

      // Fetch manufacturers
      const supplierAction = await dispatch(getImageManufacturer(manufacturePayload));
      const fetchedSupplierData = supplierAction.payload || [];

      if (!Array.isArray(fetchedSupplierData)) {
        console.error("Invalid supplier data format.");
        setLoading(false); // Set loading to false in case of an error
        return;
      }

      // Fetch images if manufacturers are available
      if (fetchedSupplierData.length > 0) {
        const manufacturer = fetchedSupplierData[0].manufacturer || "";
        const payload = [{
          partNumber: part.partNumber || "",
          supplier: manufacturer,
        }];
        const imagesAction = await dispatch(getPartImages(payload));
        const images = imagesAction.payload || [];

        if (Array.isArray(images)) {
          const partImages = images.find(
            (item) => item.partNumber === payload[0].partNumber
          )?.partImages || [];

          setPartImages(partImages);
        } else {
          console.error("Invalid images data format.");
        }
      } else {
        console.warn("No manufacturers available.");
      }
    } catch (error) {
      console.error("Error fetching part images:", error);
    } finally {
      setLoading(false); 
    }
  };

  const handleSelect = (selectedIndex, e) => {
    setCurZoom(0);
    setThumbnailImgStyle({
      transform: "scale(1)",
      maxWidth: "250px",
      maxHeight: "250px",
      width: "100%",
      marginTop: "250px",
      marginLeft: "250px",
    });
    setIndex(selectedIndex);
  };

  const handlePrint = () => {
    if (imagePrintRef.current[index]?.innerHTML) {
      const w = window.open();
      w.document.write(imagePrintRef.current[index].innerHTML);
      w.print();
      w.close();
    } else {
      console.error("No content to print.");
    }
  };

  const zoomInOut = (e, zoomingIn) => {
    let currentZoom = curZoom;
    if (zoomingIn) {
      currentZoom++;
    } else {
      currentZoom--;
    }
    setCurZoom(currentZoom);
    setZoomLevel(currentZoom);
  };

  const setZoomLevel = (currentZoom) => {
    let curScale = 1 + currentZoom * 0.1;
    setImgStyle({
      transform: "scale(" + curScale + ")",
      maxWidth: "1000px",
      width: "100%",
    });
    setThumbnailImgStyle({
      transform: "scale(" + curScale + ")",
      maxWidth: "250px",
      maxHeight: "250px",
      width: "100%",
      marginTop: "250px",
      marginLeft: "250px",
    });
  };

  if (!showImagesSlider) {
    return null;
  }

  return (
    <div className="imageslidercomponent">
      {loading && <div className="custom_spinner_container">
        <Spinner className="custom_spinner" animation="border" />
      </div>}

      {/* Carousel for displaying images */}
      {!loading && partImages.length > 0 ? (
        <Carousel
          activeIndex={index}
          interval={null}
          onSelect={handleSelect}
          style={{ maxWidth: "500px", margin: "0 auto" }}
        >
          {partImages.map((image, key) => (
            <Carousel.Item key={key}>
              <div className="imageScaleWrapper">
                <div
                  className="imageContainer row"
                  ref={(el) => (imagePrintRef.current[key] = el)}
                  style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}
                >
                  <img
                    style={imgStyle}
                    src={`${image.url}?${getImageURLCookieDetails()}`}
                    alt="Image"
                  />
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      ) : !loading && (
        <div className="imageScaleWrapper">
          <div
            className="imageContainer row"
            style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}
          >
            <img
              style={imgStyle}
              src="/noImage.jpg"
              alt="No Image Available"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ImagesSliderComponent;
